module.exports = __webpack_public_path__ + "img/juniper.4ae5d5d4.svg";